interface FilterDrawerProps {
  // Current filter values
  filterColor: string;
  filterVarietal: string;
  filterCountry: string;
  sortBy: string;
  // Options
  varietals: string[];
  countries: string[];
  resultCount: number;
  // Handlers
  onColorChange: (value: string) => void;
  onVarietalChange: (value: string) => void;
  onCountryChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onClear: () => void;
  onClose: () => void;
}

export function FilterDrawer({
  filterColor,
  filterVarietal,
  filterCountry,
  sortBy,
  varietals,
  countries,
  resultCount,
  onColorChange,
  onVarietalChange,
  onCountryChange,
  onSortChange,
  onClear,
  onClose
}: FilterDrawerProps) {
  const hasActiveFilters = filterColor || filterVarietal || filterCountry || sortBy !== 'name';

  const colorOptions = [
    { value: '', label: 'All Wines' },
    { value: 'red', label: 'Red' },
    { value: 'white', label: 'White' },
    { value: 'rosé', label: 'Rosé' },
    { value: 'orange', label: 'Orange' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'vintage-desc', label: 'Vintage (Newest)' },
    { value: 'vintage-asc', label: 'Vintage (Oldest)' },
    { value: 'recent', label: 'Recently Added' },
    { value: 'price-desc', label: 'Price (High-Low)' },
    { value: 'price-asc', label: 'Price (Low-High)' }
  ];

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
    >
      <div 
        className="ios-sheet w-full"
        style={{ maxHeight: '85vh', overflowY: 'auto' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="ios-sheet-handle" />

        {/* Header */}
        <div style={{ 
          padding: '0 20px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-wine)',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <h2 className="wine-title" style={{ 
            fontSize: '18px', 
            margin: 0,
            color: 'var(--color-text)'
          }}>
            Filter & Sort
          </h2>
          {hasActiveFilters ? (
            <button
              onClick={onClear}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-wine)',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              Clear All
            </button>
          ) : (
            <div style={{ width: '60px' }} />
          )}
        </div>

        <div style={{ padding: '0 20px 20px' }}>
          {/* Wine Color */}
          <div style={{ marginBottom: '20px' }}>
            <label className="ios-label">Color</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {colorOptions.map(option => (
                <button
                  key={option.value}
                  onClick={() => onColorChange(option.value)}
                  className={`ios-pill ${filterColor === option.value ? 'active' : ''}`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          {/* Varietal */}
          {varietals.length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <label className="ios-label">Varietal</label>
              <select
                value={filterVarietal}
                onChange={(e) => onVarietalChange(e.target.value)}
                className="ios-input"
              >
                <option value="">All Varietals</option>
                {varietals.map(v => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
            </div>
          )}

          {/* Country */}
          {countries.length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <label className="ios-label">Country</label>
              <select
                value={filterCountry}
                onChange={(e) => onCountryChange(e.target.value)}
                className="ios-input"
              >
                <option value="">All Countries</option>
                {countries.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
          )}

          {/* Sort */}
          <div style={{ marginBottom: '24px' }}>
            <label className="ios-label">Sort By</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {sortOptions.map(option => (
                <button
                  key={option.value}
                  onClick={() => onSortChange(option.value)}
                  className={`ios-pill ${sortBy === option.value ? 'active' : ''}`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          {/* Apply Button */}
          <button
            onClick={onClose}
            className="ios-btn ios-btn-primary w-full"
          >
            Show {resultCount} Result{resultCount !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  );
}
